import { findDataInFields } from "../../../utils/helperFuctions";

const CollectionDisplay = ({ name, currentFields, withDefault }) => {
  const data = findDataInFields(
    currentFields,
    withDefault === true ? name + ".defaultValue" : name
  );

  if (!data?.length) {
    return (
      <div className="text-center py-8 text-gray-500 text-lg">
        No data found.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table
        className="min-w-[500px] w-full border-separate border-spacing-0 shadow-sm rounded-lg bg-white"
        style={{ tableLayout: "fixed" }}
      >
        <thead>
          <tr className="bg-gray-50">
            <th className="py-3 px-6 text-left font-semibold text-gray-700 border-b border-gray-200 text-[14px]">
              Branch
            </th>
            <th className="py-3 px-6 text-left font-semibold text-gray-700 border-b border-gray-200 text-[14px]">
              Reservation Balance
            </th>
            <th className="py-3 px-6 text-left font-semibold text-gray-700 border-b border-gray-200 text-[14px]">
              Security Deposit Balance
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, i) => (
            <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
              <td className="py-3 px-6 text-left border-b border-gray-100 font-medium text-[14px]">
                {item.branch?.Name || "-"}
              </td>
              <td className="py-3 px-6 text-left border-b border-gray-100 font-semibol text-[14px]">
                {item.branch?.currency?.code}{" "}
                {item.reservations_total_balance.toFixed(2)}
              </td>
              <td className="py-3 px-6 text-left border-b border-gray-100  text-[14px]">
                {item.branch?.currency?.code}{" "}
                {item.deposits_total_balance.toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CollectionDisplay;
